
import {
  IonButton,
  IonContent, IonIcon,
  IonPage,
} from '@ionic/vue';
import { computed, defineComponent, onMounted, ref } from 'vue';
import TheHeaderLarge from "@/components/TheHeaderLarge.vue";
import TheList from "@/components/List/TheList.vue";
import { useRoute } from "vue-router";
import UsePushLink from "@/composables/usePushLink";
import { programService } from "@/services/program.service";
import { trash, today } from 'ionicons/icons';
import useMyAgenda from "@/composables/useMyAgenda";
import { Presentation } from "@/interfaces/Program/Presentation";
import AppInfoGtm from "@/components/GTM/AppInfoGtm.vue";

export default defineComponent({
  name: 'Presentations',
  components: {
    AppInfoGtm,
    TheList,
    TheHeaderLarge,
    IonContent,
    IonPage,
    IonButton,
    IonIcon,
  },
  setup() {
    const route = useRoute()
    const eventId: string = route.params.eventId.toString()
    const dayId: string = route.params.dayId.toString()
    const { getUrl } = UsePushLink()
    const day = ref('')
    const presentations = ref<Presentation[]>([])
    const { addPresentation, removePresentation, hasPresentation } = useMyAgenda(eventId)

    const presentationsList = computed(() => {

      if ( !presentations.value.length ) {
        return []
      }

      return presentations.value.map((presentation) => {
        return {
          id: presentation.id,
          title: presentation.titulo,
          hour: presentation.hora,
          category: presentation.keynote ? 'Keynote' : undefined,
          important: (presentation.keynote),
          link: getUrl('Presentation', { eventId: eventId, presentationId: presentation.id.toString() }),
          extraData: {
            day: day.value,
            selected: hasPresentation(presentation.id),
          }
        }
      })
    })


    onMounted(async () => {
      const presentationsData = await programService.presentations(eventId, dayId)
      day.value = presentationsData.dia + ' ' + presentationsData.fecha
      presentations.value = presentationsData.presentaciones
    })

    return {
      presentations,
      presentationsList,
      day,
      addPresentation,
      removePresentation,
      trash,
      today
    }
  }
});
